// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lh-1";
export var stateContainer = "_lh-0";